<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptertitle">Table of Contents</h1><p class="left"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="left"><a href="#/toc">Table of Contents</a></p>
<p class="left"><a href="#/front01">Copyright</a></p>
<p class="left"><a href="#/front02">Dedication</a></p>
<p class="left"><a href="#/front03">Epigraph</a></p>
<p class="left"><a href="#/front04">Foreword</a></p>
<p class="left"><a href="#/front05">Preface</a></p>
<p class="left"><a href="#/front06">Acknowledgments</a></p>
<p class="left"><a href="#/front07">Introduction</a></p>
<p class="left"><a href="#/c0001">PHASE ONE</a></p>
<p class="left"><a href="#/c001">1. Beverages</a></p>
<p class="left"><a href="#/c002">2. When the Craving Hits</a></p>
<p class="left"><span href="#/c003" title="Link target outside of Sample">3. The Serenity of Soup</span></p>
<p class="left"><span href="#/c004" title="Link target outside of Sample">4. Keeping It Simple</span></p>
<p class="left"><span href="#/c0002" title="Link target outside of Sample">PHASE TWO</span></p>
<p class="left"><span href="#/c005" title="Link target outside of Sample">5. Weekend Breakfasts and Brunches</span></p>
<p class="left"><span href="#/c006" title="Link target outside of Sample">6. Old-Fashioned Entrées That Feed the Soul</span></p>
<p class="left"><span href="#/c007" title="Link target outside of Sample">7. Supportive Sides, Vegetables, and Complements</span></p>
<p class="left"><span href="#/c008" title="Link target outside of Sample">8. Cozy Conclusions</span></p>
<p class="left"><span href="#/c0003" title="Link target outside of Sample">PHASE THREE</span></p>
<p class="left"><span href="#/c009" title="Link target outside of Sample">9. Salads</span></p>
<p class="left"><span href="#/c010" title="Link target outside of Sample">10. Vegetarian Cooking</span></p>
<p class="left"><span href="#/c011" title="Link target outside of Sample">11. When Food is Your Preventive Medicine</span></p>
<p class="left"><span href="#/c012" title="Link target outside of Sample">12. Sober Makeovers</span></p>
<p class="left"><span href="#/back01" title="Link target outside of Sample">Bibliography</span></p>
<p class="left"><span href="#/back02" title="Link target outside of Sample">Resources</span></p>
<p class="left"><span href="#/back03" title="Link target outside of Sample">Index</span></p>
<p class="left"><span href="#/footnotes" title="Link target outside of Sample">Footnotes</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?4ca7ff4e